export enum EPageType {
  MAIN = 'main',
  MAIN_AUTHENTICATION = 'mainAuthentication',
  MAIN_COMMERCIAL = 'mainCommercial',
  MAIN_COMPARE = 'mainCompare',
  MAIN_COUNTRYSIDE = 'mainCountryside',
  MAIN_EVALUATION = 'mainEvaluation',
  MAIN_MORTGAGE = 'mainMortgage',
  MAIN_RENT = 'mainRent',
  MAIN_RENT_DAILY = 'mainRentDaily',
  MAIN_RESIDENTIAL_COMPLEXES = 'mainResidentialComplexes',
  MAIN_SALE = 'mainSale',
  MAIN_SERVICES = 'mainServices',
  OTHER = 'other',
  SEARCH_RENT_DAILY = 'searchRentDaily',
  SEARCH = 'search',
}

export type TPageType = `${EPageType}`;
